import React from "react";

function ProfileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g
        id="Group_24042"
        data-name="Group 24042"
        transform="translate(-6559 -2124)"
      >
        <rect
          id="Rectangle_12671"
          data-name="Rectangle 12671"
          width="32"
          height="32"
          transform="translate(6559 2124)"
          fill="var(--primary-black)"
          opacity="0"
        />
        <path
          id="Path_16178"
          data-name="Path 16178"
          d="M4,25a9.143,9.143,0,1,1,18.286,0H20A6.857,6.857,0,0,0,6.286,25Zm9.143-10.286A6.857,6.857,0,1,1,20,7.857,6.855,6.855,0,0,1,13.143,14.714Zm0-2.286A4.571,4.571,0,1,0,8.571,7.857,4.57,4.57,0,0,0,13.143,12.429Z"
          transform="translate(6562 2127)"
          fill="var(--primary-black)"
        />
      </g>
    </svg>
  );
}

export default ProfileIcon;
